import { object, string, array } from 'yup';
import { RADIO_TRUE, RADIO_FALSE, BENEFITS, NO_RENEWALS, SOLAR, EVERYDAY_REWARDS, HOME_SUPPORT, NO_REWARDS } from './constants';

const NO_SELECTION_ERROR = 'Not so fast! You must select an option before proceeding.';

const REQUIRED_OPTION_VALIDATION = string()
  .required(NO_SELECTION_ERROR)
  .oneOf([RADIO_TRUE, RADIO_FALSE], NO_SELECTION_ERROR);

const PLAN_ERROR =
  'Sorry, it looks like we don’t have any plans available for you right now. Get in touch on live chat or try calling us on 13 24 61.';
export const AddressStepValidation = object()
  .shape({
    postcode: string().when('usePostcode', {
      is: true,
      then: string()
        .required('Please enter your postcode')
        .length(4, 'Your postcode needs to be 4 digits'),
      otherwise: string()
        .nullable()
        .notRequired(),
    }),
    plans: array()
      .required(PLAN_ERROR)
      .min(1, PLAN_ERROR),
  })
  .test({
    name: 'address',
    exclusive: false,
    message: 'Please enter your connection address',
    test: ({ address, usePostcode }) => (usePostcode ? true : !!address),
  });

export const EnergyTypeVadidation = object().test(
  'hasSelectedEnergyTypes',
  'Please select an energy type',
  ({ electricity, gas }) => electricity || gas,
);

export const RenewableValidation = object().shape({
  renewable: REQUIRED_OPTION_VALIDATION,
  greenElectricity: string().when(['electricity', 'renewable'], (gas, renewable) =>
    gas === RADIO_TRUE && renewable === RADIO_TRUE
      ? string()
          .required()
          .min(1)
      : string()
          .nullable()
          .notRequired(),
  ),
  greenGas: string().when(['gas', 'renewable'], (gas, renewable) =>
    gas === RADIO_TRUE && renewable === RADIO_TRUE
      ? string()
          .required()
          .min(1)
      : string()
          .nullable()
          .notRequired(),
  ),
});

export const PlanTypeValidation = object().shape({
  planType: string()
    .required(NO_SELECTION_ERROR)
    .oneOf([BENEFITS, NO_RENEWALS, SOLAR], NO_SELECTION_ERROR),
});

export const RewardTypeValidation = object().shape({
  rewardType: string()
    .required(NO_SELECTION_ERROR)
    .oneOf([EVERYDAY_REWARDS, HOME_SUPPORT, NO_REWARDS])
});
